import tw, { styled } from "twin.macro";

export const StyledTooltipWrapper = styled.div`
  ${tw`p-s flex flex-col gap-s w-full`}
`;

export const StyledTooltipHead = styled.div`
  ${tw`flex justify-between items-center`}
`;
